module.exports = __webpack_public_path__ + "static/media/ic_hide_web_rtv_hover.8b8c2833.svg";